import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://iakwjtwvcpqnpaduhdbj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlha3dqdHd2Y3BxbnBhZHVoZGJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM1NTIyOTMsImV4cCI6MjA2OTEyODI5M30.mCiwpxaEOjGZhG5h1fMiE5khFWYw33HXAJYbsydyqjA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

